import { useEffect, useState } from "react";
import { useReadThemeCtx } from "../../lib/ReadThemeContext";

export function DocsTOC({ toc }) {
  const [activeId, setActiveId] = useState(null);
  const { theme } = useReadThemeCtx();
  const isLight = theme === "light";

  useEffect(() => {
    if (!toc || toc.length === 0) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: "-30% 0px -60% 0px" }
    );
    toc.forEach((h) => {
      const el = document.getElementById(h.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [toc]);

  const onClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top, behavior: "smooth" });
    window.history.replaceState(null, "", `#${id}`);
  };

  if (!toc || toc.length === 0) return null;

  const headerColor = isLight ? "text-aubergine/55" : "text-bone/55";
  const railColor = isLight ? "border-aubergine/10" : "border-champ-light/10";
  const inactive = isLight ? "border-transparent text-aubergine/55 hover:text-aubergine" : "border-transparent text-bone/55 hover:text-bone";
  const active = "border-champagne text-champagne";

  return (
    <nav className="sticky top-28" data-testid="docs-toc">
      <p className={`font-mono text-[10px] uppercase tracking-[0.15em] mb-3 ${headerColor}`}>On this page</p>
      <ul className={`space-y-1.5 border-l ${railColor}`}>
        {toc.map((h) => (
          <li key={h.id}>
            <a
              href={`#${h.id}`}
              onClick={(e) => onClick(e, h.id)}
              data-testid={`docs-toc-link-${h.id}`}
              className={`block border-l-2 -ml-px py-1 text-xs transition-colors ${
                activeId === h.id ? active : inactive
              } ${h.level === 3 ? "pl-6" : "pl-3"}`}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
